import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowFirstSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5h2v14H6V5Zm12 1.414L12.414 12 18 17.586 16.586 19l-7-7 7-7L18 6.414Z"
    />
  </svg>
);
export default IconArrowFirstSizeM;
